import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDesignSystem20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconDesignSystem20"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#DesignSystem20)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M16.77 4.89 15 3.123l-1.283 1.282 1.77 1.77zM4.824 13.298l7.831-7.832 1.77 1.77-7.832 7.83-2.268.5zm9.184-3.525 3.82-3.82a1.5 1.5 0 0 0 0-2.122l-1.768-1.77a1.5 1.5 0 0 0-2.122 0l-3.82 3.821-3.666-3.665a2 2 0 0 0-2.828 0L2.211 3.63a2 2 0 0 0 0 2.828l3.665 3.666-2.422 2.422-.762 3.46a1 1 0 0 0 1.192 1.192l3.46-.762 2.423-2.422 3.676 3.676a2 2 0 0 0 2.828 0l1.414-1.414a2 2 0 0 0 0-2.828zm-1.06 1.06-2.122 2.122 3.676 3.675a.5.5 0 0 0 .707 0l1.415-1.414a.5.5 0 0 0 0-.707l-1.036-1.035-1.057 1.058a.75.75 0 0 1-1.06-1.061l1.057-1.058zm-6.011-1.77L3.271 5.398a.5.5 0 0 1 0-.707l1.415-1.415a.5.5 0 0 1 .707 0l1.136 1.136L5.47 5.47a.75.75 0 0 0 1.06 1.06l1.06-1.057 1.47 1.469z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="DesignSystem20">
                        <path fill="#fff" d="M0 0h20v20H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconDesignSystem20);
